// extracted by mini-css-extract-plugin
export default {"card":"MediaCard_card__Fu1xw","title":"MediaCard_title__KfLTR","description":"MediaCard_description__6mBVH","date":"MediaCard_date__5wauX"};